"use client";

import React from "react";
import { Mail, MapPin, Phone, Send } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const contacts = [{
  id: "phone",
  icon: Phone,
  label: "Direct Line",
  value: "+1 (555) 012-3456",
  link: "tel:+15550123456"
}, {
  id: "telegram",
  icon: Send,
  label: "Digital Concierge",
  value: "@mozacasa_support",
  link: "#"
}, {
  id: "email",
  icon: Mail,
  label: "Inquiries",
  value: "hello@mozacasa.com",
  link: "mailto:hello@mozacasa.com"
}, {
  id: "address",
  icon: MapPin,
  label: "Studio",
  value: "Cupertino, California",
  link: "#"
}];
export default function ContactUs() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223604" id="direct-support" className="dark bg-background text-foreground py-20 px-4 md:px-8 lg:px-16 overflow-hidden">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-16 items-center">
        
        {}
        <div ref={leftRef} className={`w-full lg:w-2/5 flex flex-col gap-12 transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
          <div className="space-y-4">
            <h2 className="font-default text-4xl md:text-5xl font-bold tracking-tight text-primary">
              Direct Support
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed font-default">
              Experience the art of simple living. Whether you're starting your HomeKit journey or refining your automation, our team is here to guide your digital zen.
            </p>
          </div>

          <div className="flex flex-col gap-8">
            {contacts.map((contact, i) => {
            const Icon = contact.icon;
            return <div data-index={i} key={contact.id}>
                  <Link to={contact.link} className="flex items-center gap-6 group">
                    <div className="flex-shrink-0 w-16 h-16 rounded-full bg-accent/10 flex items-center justify-center transition-all duration-300 group-hover:scale-110 group-hover:bg-accent/20">
                      <Icon className="w-8 h-8 text-primary" />
                    </div>
                    <div className="flex flex-col">
                      <span className="text-xs text-muted-foreground font-default uppercase tracking-widest mb-1">
                        {contact.label}
                      </span>
                      <span className="text-xl md:text-2xl font-default font-semibold text-foreground group-hover:text-primary transition-colors relative after:content-[''] after:absolute after:bottom-0 after:left-0 after:w-0 after:h-[1px] after:bg-primary after:transition-all after:duration-300 group-hover:after:w-full">
                        {contact.value}
                      </span>
                    </div>
                  </Link>
                </div>;
          })}
          </div>
        </div>

        {}
        <div ref={rightRef} className={`w-full lg:w-3/5 h-[500px] lg:h-[700px] relative rounded-3xl overflow-hidden shadow-4xl transition-all duration-1000 delay-200 ease-out ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
          <div className="absolute inset-0 bg-gradient-to-t from-background/60 via-transparent to-transparent z-10 pointer-events-none" />
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1647152/img/moza_casa_minimalist_interior.png" alt="Moza Casa Minimalist Smart Home Interior" className="w-full h-full object-cover transition-transform duration-1000 hover:scale-105" />
        </div>

      </div>
    </section>;
}